// Fallback mock data matching 100% of the legacy static site
// Used as default state so pages always render beautifully even if database is connecting/loading

export const FALLBACK_PARTNERS = [
  { id: '1', name: 'Imexpharm', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779247992287.svg', website_url: 'https://imexpharm.com' },
  { id: '2', name: 'DHG', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779248107439.svg', website_url: 'https://dhgpharma.com.vn' },
  { id: '3', name: 'Traphaco', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779249532928.svg', website_url: 'https://traphaco.com.vn' },
  { id: '4', name: 'PH', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250363447.svg' },
  { id: '5', name: 'Boston', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250134839.svg' },
  { id: '6', name: 'OPC', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779249856965.svg' },
  { id: '7', name: 'Sanofi', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250196861.svg' },
  { id: '8', name: 'vidipha', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779249615199.svg' },
  { id: '9', name: 'Nam Hà', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250512180.svg' },
  { id: '10', name: 'BR Pharma', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779250818392.svg' },
  { id: '11', name: 'TVPharm', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779251145343.svg' },
  { id: '12', name: 'PV', logo_url: 'https://ckjfwkgtjwiiolqqmnoc.supabase.co/storage/v1/object/public/site-assets/partner-logos/1779251263283.svg' }
];

export const FALLBACK_JOBS = [
  {
    id: '1',
    key: 'nhan-vien-kinh-doanh',
    title: 'Nhân viên kinh doanh',
    department: 'kinh-doanh',
    department_label: 'Kinh doanh',
    headcount: 5,
    is_hot: true,
    salary_summary: 'Lương cứng 7.5tr – 8.5tr + Phụ cấp gửi xe + Thưởng + Hoa hồng (Thu nhập 9 - 25tr không giới hạn theo doanh số)',
    requirements_summary: [
      'Nam/Nữ: Tuổi từ: 21-30',
      'Tốt nghiệp Cao đẳng trở lên các ngành nghề: Y, Dược, Quản trị kinh doanh… hoặc các ngành nghề liên quan.',
      'Không yêu cầu kinh nghiệm, ứng viên có từng làm sale về lĩnh vực phân phối, bán lẻ Dược, hóa-mỹ phẩm, thực phẩm chức năng… là lợi thế.'
    ],
    jd: {
      objective: [
        'Thực hiện hoạt động bán hàng để đạt và vượt chỉ tiêu doanh số, góp phần mở rộng thị phần và tăng trưởng doanh thu.',
        'Chăm sóc khách hàng hiện có, phát triển khách hàng tiềm năng và phản hồi thông tin thị trường nhằm nâng cao chất lượng sản phẩm, dịch vụ.'
      ],
      responsibilities: [
        'Chăm sóc khách hàng hiện có do công ty cung cấp.',
        'Tìm kiếm & khai thác khách hàng mới.',
        'Xử lý đơn hàng, phối hợp với phòng kế toán theo dõi công nợ.',
        'Nắm bắt nhu cầu thông tin khách hàng để xây dựng và phát triển mối quan hệ với khách hàng, chăm sóc và tạo trải nghiệm khách hàng tốt trước và sau bán.',
        'Báo cáo tình hình công việc định kỳ hàng tuần để phối hợp xử bán.',
        'Báo cáo lên các cấp quản lý về nhu cầu, vấn đề, mối quan tâm của khách bán.',
        'Thực hiện các công việc khác theo yêu cầu của cấp quản lý.'
      ],
      requirements: [
        'Nam/Nữ: Tuổi từ: 21-30',
        'Tốt nghiệp Cao đẳng trở lên các ngành nghề: Y, Dược, Quản trị kinh doanh… hoặc các ngành nghề liên quan.',
        'Không yêu cầu kinh nghiệm, ứng viên có từng làm sale về lĩnh vực phân phối, bán lẻ Dược, hóa-mỹ phẩm, thực phẩm chức năng… là lợi thế.'
      ],
      benefits: [
        'Được đào tạo thêm về bán hàng, Kinh doanh, quản lý, lãnh đạo trong quá trình làm việc.',
        'Môi trường làm việc Gen Z, trẻ trung, năng động, thân thiện.',
        'Được hỗ trợ tham gia các khóa học bên ngoài bởi các trường đào tạo như Trường doanh nhân HBR, Trường đào tạo doanh nhân PTI',
        'Lương tháng thứ 13, lễ, tết và đóng BHXH theo đúng quy định của nhà nước.',
        'Được xét nâng chế độ, vị trí theo kết quả công việc và lộ trình của công ty.',
        'Trang phục không gò bó khi đi làm (không vi phạm thuần phong mỹ tục).',
        'Được đi du lịch, teamwork hàng năm, liên hoan sinh nhật hàng quý cùng công ty.'
      ],
      salary_full: 'Lương cứng 7.5tr – 8.5tr + Phụ cấp gửi xe + Thưởng + Hoa hồng (Thu nhập 9 - 25tr không giới hạn theo doanh số)'
    }
  },
  {
    id: '2',
    key: 'marketing-excutive',
    title: 'Marketing Excutive',
    department: 'marketing',
    department_label: 'Marketing',
    headcount: 1,
    is_hot: true,
    salary_summary: 'Lương cứng: 12.000.000 đồng - 17.000.000 đồng + Phụ cấp + Thưởng',
    requirements_summary: [
      'Nam/Nữ: Tuổi từ: 24-30',
      'Tốt nghiệp Đại học trở lên ngành liên quan đến Marketing, Quản trị kinh doanh, Truyền thông…',
      'Có ít nhất 1 năm kinh nghiệm làm việc ở vị trí tương đương.'
    ],
    jd: {
      objective: [
        'Xây dựng và thực thi các chiến dịch marketing đa kênh nhằm gia tăng nhận diện thương hiệu Thế Thảo Pharma.',
        'Hỗ trợ kênh bán lẻ và đối tác nhà thuốc các chương trình kích cầu, thúc đẩy doanh số.'
      ],
      responsibilities: [
        'Lên kế hoạch và triển khai nội dung cho các kênh truyền thông số (Fanpage, Website, Zalo OA).',
        'Phối hợp với phòng Kinh doanh xây dựng tài liệu bán hàng (Sales kit, catalogue, POSM).',
        'Theo dõi, đo lường và tối ưu hiệu quả các chiến dịch marketing.',
        'Nghiên cứu thị trường và đối thủ cạnh tranh để đề xuất giải pháp mới.'
      ],
      requirements: [
        'Nam/Nữ: Tuổi từ: 24-30',
        'Tốt nghiệp Đại học trở lên ngành liên quan đến Marketing, Quản trị kinh doanh, Truyền thông…',
        'Có ít nhất 1 năm kinh nghiệm làm việc ở vị trí tương đương.',
        'Đã từng làm việc với các agency hoặc đối tác về marketing là lợi thế. Hiểu biết về Branding, Content MKT, SEO.'
      ],
      benefits: [
        'Được đào tạo thêm các kiến thức chuyên môn Marketing',
        'Được hỗ trợ tham gia các khóa học bên ngoài bởi các trường đào tạo như Trường doanh nhân HBR, Trường đào tạo doanh nhân PTI,...',
        'Được xét nâng chế độ, vị trí theo kết quả công việc và lộ trình của công ty',
        'Được làm việc trong môi trường trẻ trung, năng động cùng với các bạn GenZ;',
        'Được đi du lịch, teamwork hàng năm, liên hoan sinh nhật hàng quý cùng công ty;',
        'Các chế độ lương thưởng lễ, tết và BHXH theo đúng quy định của nhà nước.',
        'Cơ hội tham gia đồng hành các dự án có ý nghĩa, giúp nâng cao chuyên môn, mở rộng network.'
      ],
      salary_full: 'Lương cứng: 12.000.000 đồng - 17.000.000 đồng + Phụ cấp + Thưởng'
    }
  }
];

export const FALLBACK_NEWS = [
  {
    id: '1',
    key: 'cap-nhat-quy-dinh-moi-ve-kiem-soat-tpcn-nam-2026',
    category: 'Pháp lý dược',
    title: 'Cập nhật quy định mới về kiểm soát TPCN năm 2026',
    lead: 'Những thay đổi trong quy định kiểm soát thực phẩm chức năng và cách nhà thuốc chuẩn bị sẵn sàng.',
    published_date: '2026-05-14',
    read_minutes: 4,
    cover_gradient: 'linear-gradient(135deg,#ecf6e3,#a4d977)'
  },
  {
    id: '2',
    key: 'khoa-dao-tao-marketing-nha-thuoc-50-dot-4',
    category: 'Hoạt động',
    title: 'Khoá đào tạo "Marketing Nhà Thuốc 5.0" — đợt 4 toàn quốc',
    lead: 'Hơn 300 chủ nhà thuốc tham gia khoá đào tạo miễn phí về marketing số và chăm sóc khách hàng.',
    published_date: '2026-05-02',
    read_minutes: 3,
    cover_gradient: 'linear-gradient(135deg,#a4d977,#50b848)'
  },
  {
    id: '3',
    key: 'hanh-trinh-thang-4-trao-142-tu-thuoc-tai-ha-giang-son-la',
    category: 'Tủ thuốc cho em',
    title: 'Hành trình tháng 4: trao 142 tủ thuốc tại Hà Giang & Sơn La',
    lead: 'Cùng đội tình nguyện Thế Thảo Pharma đến với các điểm trường vùng cao trong chuyến đi mùa xuân.',
    published_date: '2026-04-28',
    read_minutes: 5,
    cover_gradient: 'linear-gradient(135deg,#ecf6e3,#72bf44)'
  },
  {
    id: '4',
    key: 'fefo-phuong-phap-quan-ly-kho-hang-nha-thuoc-nen-biet',
    category: 'Kiến thức ngành',
    title: 'FEFO — Phương pháp quản lý kho hàng nhà thuốc nên biết',
    lead: 'Hướng dẫn áp dụng FEFO để tránh hàng cận date và tối ưu doanh thu cho nhà thuốc truyền thống.',
    published_date: '2026-04-20',
    read_minutes: 6,
    cover_gradient: 'linear-gradient(135deg,#d6efff,#3cb4e7)'
  },
  {
    id: '5',
    key: 'thi-truong-otc-2026-5-co-hoi-cho-nha-thuoc-doc-lap',
    category: 'Xu hướng',
    title: 'Thị trường OTC 2026: 5 cơ hội cho nhà thuốc độc lập',
    lead: 'Khi chuỗi lớn mở rộng — đâu là chiến lược để nhà thuốc lẻ giữ khách hàng và tăng trưởng bền vững?',
    published_date: '2026-04-15',
    read_minutes: 7,
    cover_gradient: 'linear-gradient(135deg,#fff3d0,#fdb913)'
  },
  {
    id: '6',
    key: 'moi-con-so-la-mot-em-nho-khoe-lai-chia-se-tu-founder',
    category: 'Câu chuyện',
    title: '"Mỗi con số là một em nhỏ khoẻ lại" — chia sẻ từ founder',
    lead: 'Lý do chương trình Tủ Thuốc Cho Em được duy trì suốt 5 năm — câu chuyện từ Founder Thế Thảo Pharma.',
    published_date: '2026-04-08',
    read_minutes: 5,
    cover_gradient: 'linear-gradient(135deg,#ecf6e3,#a4d977)'
  }
];
